<template>
    <v-dialog :value="active" width="550" persistent>
      <v-card>
            <v-card-title class="headline">
                {{ title }}
            </v-card-title>

            <v-card-text>

            <v-list>
              <v-list-tile
                v-for="error in errors"
                :key="error"
                data-test="error-message"
              >
                <v-list-tile-content>
                  <v-list-tile-title class="red--text">
                      {{ error }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeErrorsModal" flat> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { flatMapDeep } from 'lodash'
import { mapActions } from 'vuex'

export default {
  props: {
    content: {
      type: [String, Array, Object],
      required: true
    },
    title: {
      type: String,
      default: 'Error'
    },
  },
  computed: {
    errors() {
      const input = typeof(this.content) == 'string' ? [this.content] : this.content
      return flatMapDeep(input)
    },
    active() {
      const active = this.errors ? this.errors.length : false
      return active
    }
  },
  methods: {
    ...mapActions({
      closeErrorsModal: 'root/closeErrorsModal',
    }),
  }
}
</script>
